/** Erro com resposta HTTP (4xx/5xx) veio do servidor; sem resposta é falha de rede. */
export function isRenewalHttpError(error: unknown): boolean {
  return Boolean(
    error && typeof error === 'object' && 'response' in error && (error as { response?: unknown }).response
  );
}
